import fetch from 'utils/fetch';

export function imsiQuery(keyword) {
    return fetch({
        url: '/imsiQuery',
        method: 'get',
        params : {keyword}
    });
}
export function imsiQueryPackage(keyword) {
    return fetch({
        url: '/imsiQueryPackage',
        method: 'get',
        params : {keyword}
    });
}
export function imsiQueryCdr(keyword) {
    return fetch({
        url: '/imsiQueryCdr',
        method: 'get',
        params : {keyword}
    });
}



// WEBPACK FOOTER //
// ./src/api/fastQueryOld.js